import { render } from "./WinBacks.vue?vue&type=template&id=f20dc73a"
import script from "./WinBacks.vue?vue&type=script&lang=js"
export * from "./WinBacks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__